<template>
    <div class="flex md:flex-col">
        <div>
            <AdminDashboardNav/>
        </div>
        <section class="font-poppins w-screen  p-2 md:pl-1 md:pr-1 ">
            <section class="mt-6">
                <div class=" flex justify-between md:flex-col-reverse">
                    <div class="md:mt-6">
                        <GetDate/>
                        <p class="text-blue-700 font-bold text-2xl md:text-lg">MANAGE ORDERS</p>
                    </div>

                    <div class=" mr-10">
                        <Notification/>
                    </div>
                </div>
            </section>

            <div class="flex mt-4 md:text-sm">
                <div @click="goBack" class="flex cursor-pointer">
                    <i class="fa fa-arrow-left mr-3"></i>
                    <p>Go Back</p>
                </div>
                <div class="flex ml-5 font-bold">
                    <p >Orders List</p>
                    <i class="fa fa-angle-right mt-1 ml-4"></i>
                    <p class="ml-4">Re-assign Order</p>
                </div>
            </div>

            <div class="mt-8 pb-3 flex justify-between md:flex-col md:p-2 md:text-sm">
                <div class="mt-4 w-1/2 md:w-full ">
                    <div class="flex bg-gray-100 justify-between mb-4 rounded p-3 text-sm">
                        <div class="flex">
                            <div class=" text-center  text-white">
                                <i class=" fa fa-send p-2 rounded-lg  mt-1 bg-blue-700"></i>
                            </div>
                            
                            <div class="ml-2">
                                <p class="text-blue-500">{{userOrder.items}} Delivery to {{deliveryAddress}}</p>
                                <p class="text-sm mt-1">Tracking No: <span class="text-blue-600">{{userOrder.trackingNumber}}</span></p>
                            </div>
                        </div>
                        <p class="ml-3">NGN {{userOrder.orderCost}}</p>
                    </div>
                     <button class="bg-blue-700 p-1 text-white rounded text-sm" @click="triggerReady">
                        Click here to Load Map
                    </button>
                        <place-search
                            v-bind:ready="ready"
                            placeholder="Enter a location"
                            loading="Map is loading"
                            v-bind:gps_timeout="7000"
                            v-bind:fallbackProcedure="fallbackProcedure"
                            v-bind:zoom="zoom"
                            v-bind:geolocation="geolocation"
                            v-bind:address="address"
                            v-bind:manually="manually"
                            @changed="getMapData"
                        >
                        </place-search>
                    <form @submit.prevent="reassignOrder" class="shadow-xl rounded-lg p-4 mt-4">
                        <p class="text-gray-500">Address of Order</p>
                        <div class="flex mt-10">
                            
                            <div class="flex flex-col">
                                <i class="fa fa-map-marker text-blue-400"></i>
                                <div>
                                    <p>|</p>
                                    <p>|</p>
                                </div>  
                                <i class="fa fa-map-marker"></i>
                            </div>
                            
                            <div class="ml-5">
                                <div>
                                    <p>Address</p>
                                    <input class="w-full border bg-gray-100 p-2 rounded-lg"  type="text" name="pickUp" id="pickUp" :value="place.address_description" >
                                </div>
                                <p class="font-bold">{{userOrder.pickupAddress}}</p>
                                <div class="mt-2">
                                    <p>Sender Details:</p>
                                    <p class="font-bold">Name: {{name}}</p>
                                    <p class="font-bold">Phone Number: {{number}}</p>
                                </div>
                                <div class="mt-2">
                                    <p>Order ID:</p>
                                    <p>{{id}}</p>
                                </div>
                            </div>
                            
                        </div>
                        
                   
                    <div class="mt-6">
                        <div class="flex">
                            <p>Re-assign Task to</p>
                            <div>
                                <input class="p-2 rounded-lg border bg-gray-100 w-full" type="text" name="riderId" id="riderId" placeholder="Enter Rider ID" v-model="uniqueId">
                                <p class="mt-2">Or <span class="text-blue-600 cursor-pointer" @click="getAvailableRiders">click here to search nearest available rider</span></p>
                                <p class="text-red-500">{{error}}</p>
                                <button class="p-3 mt-4 rounded bg-gray-200" @click="reassignOrder">
                                    Re-assign Task
                                    <i v-if="isLoading" class="fa fa-spin fa-spinner"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                     </form>
                </div>

                <div class="ml-10 text-sm w-1/2 md:w-full md:ml-0 md:mt-3">
                    <p class="font-semibold">Available Riders</p>
                    <p>{{noRider}}</p>
                    <div v-for="riders in availableRiders" :key="riders">
                        <p>{{riders}}</p>
                    </div>
                </div>
            </div>

            <div>
                <Modal
                v-show="isModalVisible"
                @close="closeModal"
                :uniqueId="uniqueId"
                />
            </div>
        </section>
    </div>
</template>

<script>
import Notification from '../Notification.vue';
import AdminDashboardNav from '../AdminDashboardNav.vue';
import GetDate from '../GetDate.vue';
import PlaceSearch from './PlaceSearch.vue';
import axios from 'axios';
import {baseUrl} from '../../../Config';
const url = baseUrl;
import Modal from './Modal.vue';
export default {
    props:['id', 'trackNumber', 'name', 'number'],
    components: {
        Notification,
        AdminDashboardNav,
        GetDate,
        PlaceSearch,
        Modal
    },

    data() {
        return {
            isModalVisible : false,
            ready: false, //Add ready:false to stop map from loading, and then when changed to true map will auto load
            fallbackProcedure: "gps", //gps | geolocation | address | manually
            zoom: 17, //Default Zoom
            geolocation: {
                // If GPS and Find by address fails then, map will be positioned by a default geolocation
                lat: 31.73858,
                lng: -35.98628,
                zoom: 2,
            },
            address: {
                query: "Albania, Tirane", //If GPS fails, Find by address is triggered
                zoom: 10,
            },
            manually: {
                address_description: "Nigeria",
                city: "Nigeria",
                country: "Nigeria",
                lat: 41.3267905,
                lng: 19.8060475,
                state: "Nigeria",
                zip_code: "",
                zoom: 17,
            },
            place: {},
            form_data: {},
            availableRiders: [],
            noRider: "",
            userOrder: [],
            riderId: "",
            riderEmail: "",
            error: "",
            isLoading: false,
            uniqueId: "",
            deliveryAddress:""
        }
    },

    mounted() {
        this.getOrder();
        this.getAvailableRiders();
        this.getRiderInfo();
    },

    methods: {
        showModal() {
        this.isModalVisible = true;
        },
        closeModal() {
            this.isModalVisible = false;
        },
        goBack() {
            this.$router.go(-1);
        },
        getMapData(place) {
            this.place = place;
            },
            triggerReady() {
            this.fallbackProcedure = "manually";
            this.ready = true;
        },
        

        reassignOrder() {
            this.isLoading = true;
            console.log(this.riderId);
            axios({
                    method: 'PUT',
                    url: `${url}/v1/web/orders/reassign`,
                    headers: {
                        'Content-type': 'application/json',
                        Authorization: 'Bearer ' + localStorage.getItem("token"),
                        'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                    },
                    data: {
                        orderId: this.id,
                        id : this.uniqueId
                    }
                })
                .then((res) => {
                    this.isLoading = false;
                    this.isModalVisible = true
                    res;
                })
                .catch((err) => {
                    this.isLoading = false;
                    this.error = err.response.data.message

                })
        },

        getOrder() {
            axios({
                    method: 'GET',
                    url: `${url}/v1/web/orders/${this.id}`,
                    headers: {
                        'Content-type': 'application/json',
                        Authorization: 'Bearer' + localStorage.getItem("token"),
                        'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                    }
                })
                .then((res) => {
                    this.userOrder = res.data.data;
                    this.deliveryAddress = this.userOrder.deliveryAddress[0];
                })
                .catch((err) => {
                    err;
                })
        },

        getAvailableRiders() {
            axios({
                    method: 'GET',
                    url: `${url}/v1/web/riders/available/${this.place.lat}/${this.place.lng}`,
                    headers: {
                        'Content-type': 'application/json',
                        Authorization: 'Bearer' + localStorage.getItem("token"),
                        'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                    }
                })
                .then((res) => {
                    this.availableRiders = res.data.data;
                    if(this.availableRiders.length <= 0) {
                        this.noRider = "No Available Riders"
                    }
                    this.riderId = res.data.data.i;
                })
                .catch((err) => {
                    err;
                })
        },

        getRiderInfo() {
            axios({
                    method: 'GET',
                    url: `${url}/v1/web/riders/${this.id}`,
                    headers: {
                        'Content-type': 'application/json',
                        Authorization: 'Bearer' + localStorage.getItem("token"),
                        'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                    }
                })
                .then((res) => {
                    this.riderEmail = res.data.data.email;
                    console.log(res);
                })
                .catch((err) => {
                    err;
                })
            },
        }
}
</script>

